import * as React from "react";
import { Section } from "./section";

import styled from "@emotion/styled";

const StyledSectionCommon = styled.div`
  text-align: center;

  .header {
    max-width: 565px;
    margin: auto;
  }

  .h2 + p {
    margin-top: var(--macro);
  }

  &:nth-of-type(2n) {
    background: var(--off-white);
  }
`;

interface SectionCommonProps {
  children: any;
  classNames?: string;
  headerStyles?: React.CSSProperties;
  headingStyles?: React.CSSProperties;
  textStyles?: React.CSSProperties;
  styles?: React.CSSProperties;
  title: string | JSX.Element;
  text?: string | JSX.Element;
  [key: string]: any;
}

export const SectionCommon = ({
  children,
  classNames,
  title,
  text,
  headerStyles,
  headingStyles,
  textStyles,
  styles,
  id
}: SectionCommonProps) => (
  <StyledSectionCommon id={id} style={styles}>
    <Section classNames={classNames}>
      <div className="row">
        <div className="header" style={headerStyles}>
          <h2 className="h2" style={headingStyles}>{title}</h2>
          {text ? <p className="text-large" style={textStyles}>{text}</p> : null}
        </div>
        {children}
      </div>
    </Section>
  </StyledSectionCommon>
);
